import React, { useEffect, useState } from "react";

import ActivityList, { IGridLayout } from "@Components/activity/ActivityList";
import ActivityTabTitle from "@Components/activity/ActivityTabTitle";
import ActivityTabTitleSkeleton from "@Components/activity/ActivityTabTitleSkeleton";
import PublicView from "@Components/activity/PublicView";
import { useCurrentActivityQuery } from "@Components/activity/queries";
import { useHistory } from "react-router";
import PageHelmet from "@Components/shared/PageHelmet";
import { QueryKeys } from "@Constants";
import SessionManager from "@Core/session";
import { isNil, useSearchParams } from "@Utils";
import IconButton from "@Components/shared/IconButton";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const LibraryPage: React.FC = () => {
    // ** Search Params ** //
    const [searchParams] = useSearchParams();
    const currentActivityParam = searchParams.get("activity");
    const userParam = searchParams.get("user");
    const hasBoth = !isNil(currentActivityParam) && !isNil(userParam);
    const history = useHistory();

    // ** Hooks ** //
    const {
        data: currentActivity,
        isFetched,
        isFetching,
    } = useCurrentActivityQuery(currentActivityParam, QueryKeys.ActivityCurrentPublic);

    const { userId } = SessionManager.getServiceUser();
    const gridLayout: IGridLayout = { gutter: 30, xs: 1, sm: 1, md: 1, lg: 2, xl: 3, xxl: 3 };

    // ** State ** //
    const hasCurrentActivity = !isNil(currentActivity);
    const [activityView, setActivityView] = useState(false);

    useEffect(() => {
        if (hasBoth) {
            setActivityView(true);
        }
        // if the user navigates to the activity page without both params, we want to default to the library tab
        if (!hasBoth && activityView === true) {
            return setActivityView(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasBoth, currentActivityParam, userParam]);

    const onBackSelect = () => {
        history.goBack();
    };

    return (
        <div>
            <PageHelmet name={"Video Library"} />
            <div>
                {activityView ? (
                    <>
                        {hasCurrentActivity ? (
                            <>
                                <IconButton
                                    icon={<ArrowBackIosNewIcon style={{ height: "14px" }} />}
                                    className="secondary flex"
                                    onClick={onBackSelect}
                                >
                                    Back
                                </IconButton>
                                <ActivityTabTitle activity={currentActivity} />
                            </>
                        ) : (
                            <ActivityTabTitleSkeleton isLoading={isFetching && !isFetched} />
                        )}
                        <PublicView activity={currentActivity} canRender={hasCurrentActivity} />
                    </>
                ) : (
                    <>
                        <ActivityList
                            gridLayout={gridLayout}
                            queryKey={QueryKeys.ActivityListPublic}
                            userIds={[userId]}
                            onActivityClick={() => setActivityView(true)}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default LibraryPage;
